import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircleIcon } from '@hero/web-icons';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../../ui/Tooltip';

/**
 * Compact amber pin-accuracy hint used next to city names in the orders
 * table route column and the drawer route card.
 *
 * Pattern (when both sides are inaccurate): `[i] City → City [i]`
 * Hidden by the caller when `isAccurateLocation !== false`.
 */
export const InaccurateLocationHint: React.FC = () => {
  const { t } = useTranslation('m-order');

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex flex-shrink-0 items-center text-amber-600">
            <AlertCircleIcon className="size-3" />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top">{t('destination.inaccurate_location')}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
